import React from 'react'
import leftPad from 'left-pad'
import axios from 'axios'
import qr from 'qrcode'
import { connect } from 'react-redux'
import { Mask, Toast } from 'react-weui'
import { WKGreenTitle, WKOwnDialog } from '../../components/wk'
import { Page, Pay } from '../../components'
import { renderMoney, renderPopular, TimeStream } from '../../utils'
import { setEvent } from '../../services'
import timerBgImg from '../../images/groupBuy/timer-bg.png'
import groupShareGuideImg from '../../images/groupBuy/group-share-guide.png'
import closeIconImg from '../../images/groupBuy/close-icon.png'
import successIconImg from '../../images/groupBuy/success-icon.png'
import failIconImg from '../../images/groupBuy/fail-icon.png'
import failImg from '../../images/groupBuy/failed.png'
import '../../css/page/ChannelGroupBuyPage.css'

import { GroupGrayList } from '../../utils/white_list'

class ChannelGroupBuyPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isCanJoin: true,
            myActivity: '',
            isShowShareGuide: false,
            channel: {},
            stats: {},
            groupBuy: {},
            groupBuyAccess: {},
            groupActivity: {},
            isPending: true,
            deadlineInfo: {
                hour: '00', minute: '00', second: '00',
            },
            members: [],
            status: '',
            isShowBuyedDialog: false,
            isShowFullDialog: false,
            isShowToast: false,
            toastText: '',
            isShowCommonDialog: false,
            commonDialogText: '',
            isNotFound: false,
            // payed
            payedQr: '',
            payedDesc: '',
            payedTitle: '',
            payedBottom: '',
            isShowPayedDialog: false,

            isShowJoinedDialog: false,
            isShowBuyDialog: false,
        }
    }

    componentDidMount () {
        document.title = '拼团'
        this.fetchChannelInfo()
        if (this.props.location.query.show_dialog) {
            setTimeout(() => {
                this.fetchPayedInfo()
            }, 1000)
        }
        // this.fetchPayedInfo() // 千万去掉

    }

    componentWillUnmount () {
        clearInterval(this.timer)
    }

    fetchPayedInfo () {
        axios.get(`/api/marketing/groupactivity/${this.props.location.query.id}/pay_success`)
            .then(res => {
                const data = res.data.data
                if (res.data.code === 0) {
                    this.setState({
                        payedDesc: data.desc,
                        payedTitle: data.title,
                        payedBottom: data.bottom_desc,
                        isShowPayedDialog: !this.props.account.subscribed,
                    })
                    this.toQrImg(data.qrcode)
                } else {
                    // alert(res.data.msg)
                }
            })
    }

    fetchChannelInfo (isTimeOut) {
        let queryParams = {}
        if (this.props.location.query.st) {
            queryParams = { st: this.props.location.query.st }
        }
        if (this.props.location.query.inviter_id) {
            queryParams = { ...queryParams, inviter_id: this.props.location.query.inviter_id }
        }
        axios.get(`/api/marketing/groupactivity/${this.props.location.query.id}/info`, {
            params: queryParams
        })
            .then(res => {
                if (res.data.code === 0) {
                    const data = res.data.data
                    this.setState({
                        channel: data.channel_info,
                        groupBuy: data.groupbuy_info,
                        groupActivity: data.groupactivity_info,
                        groupBuyAccess: data.groupactivity_access,
                        members: data.members,
                        status: this.getStatus(data),
                        isCanJoin: data.can_join_activity,
                        myActivity: data.self_activity,
                    }, () => {
                        if (Date.now() <= data.groupactivity_info.deadline * 1000 && !isTimeOut) {
                            this.setDeadline ()
                            this.startDeadlineClock()
                        }
                    })
                    this.setShareInfo(data.share_info)
                } else {
                    this.setState({ isShowCommonDialog: true, commonDialogText: res.data.msg })
                }
            })
            .catch(err => {
                if (err.response.status === 404) {
                    this.setState({
                        isShowCommonDialog: true,
                        commonDialogText: '您访问的拼团不存在',
                        isNotFound: true,
                    })
                }
            })
            .then(res => {
                this.setState({ isPending: false })
                new Image().src = groupShareGuideImg
                new Image().src = closeIconImg
                new Image().src = successIconImg
                new Image().src = failImg
            })
    }

    getStatus (data) {
        const activityStatus = data.groupactivity_info.status
        const accessStatus = data.groupactivity_access && data.groupactivity_access.status
        if (activityStatus === 'process') {
            if (accessStatus === 'process') {
                return 'joined'
            }
            if (!accessStatus) {
                return 'noJoin'
            }
        }
        if (activityStatus === 'success') {
            if (accessStatus === 'success') {
                return 'success'
            }
            if (!accessStatus) {
                return 'close'
            }
        }
        if (accessStatus === 'failed' || (activityStatus === 'failed' && accessStatus)) {
            return 'fail'
        }
        if (activityStatus === 'failed' && !accessStatus) {
            return 'close'
        }
    }

    startDeadlineClock () {
        this.timer = setInterval(() => {
            this.setDeadline()
        }, 1000)
    }

    setDeadline () {
        const deadline = this.state.groupActivity.deadline
        const offset = deadline - Date.now() / 1000
        if (offset < 0) {
            this.setState({
                deadlineInfo: {
                    hour: '00',
                    minute: '00',
                    second: '00',
                }
            })
            setTimeout(() => {
                this.fetchChannelInfo(true)
            }, 1000)
            clearInterval(this.timer)
            return
        }
        const hour = Math.floor(offset / 3600)
        const minute = Math.floor((offset - hour * 3600) / 60)
        const second = Math.floor((offset - hour * 3600 - minute * 60))
        this.setState({
            deadlineInfo: {
                hour: leftPad(hour > 99 ? 99 : hour, 2, '0'),
                minute: leftPad(minute, 2, '0'),
                second: leftPad(second, 2, '0'),
            }
        })
    }

    renderTimer (deadlineInfo) {
        return (
            <div className="count-down">
                <div className="title">
                    距离拼团结束仅剩
                </div>
                <div className="timer" style={{backgroundImage: `url(${timerBgImg})`}}>
                    <div className="hour">{deadlineInfo.hour}</div>
                    <div className="minute">{deadlineInfo.minute}</div>
                    <div className="second">{deadlineInfo.second}</div>
                </div>
            </div>
        )
    }

    onClickPayGroupBuy () {
        if (!this.state.isCanJoin) {
            return this.setState({ isShowJoinedDialog: true })
        }
        this.props.dispatch({
            type: 'PAY_CHANNEL',
            payload: {
                params: {
                    product: 'pay_channel_groupbuy',
                    group_id: this.state.groupBuy.id,
                    activity_id: this.props.location.query.id,
                },
                success: () => {
                    this.setState({ isShowToast: true, toastText: '支付确认中' })
                    setTimeout(() => {
                        this.fetchChannelInfo()
                        this.fetchPayedInfo()
                        this.setState({ isShowToast: false, isShowBuyDialog: true})
                    }, 2000)
                },
                fail: (data) => {
                    if (data.msg.includes('手慢了')) {
                        return this.setState({ isShowFullDialog: true })
                    }
                    if (data.msg.includes('无需重复购买')) {
                        return this.setState({ isShowBuyedDialog: true })
                    }
                    this.setState({ isShowCommonDialog: true, commonDialogText: data.msg })
                },
            }
        })
    }

    setShareInfo (share_info) {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                link: share_info.share_url,
                successCallback: () => {
                    setEvent({ page: 'channel-group-buy', action: 'share', name: this.state.groupBuyAccess ? 'access' : 'noaccess' })
                    this.setState({ isShowShareGuide: false })
                },
            }
        })
    }

    toQrImg (str) {
        qr.toDataURL(str, {
            errorCorrectionLevel: 'M',
            margin: 0.5,
            type: 'image/png',
        }, (err, url) => {
            if (err) throw err
            this.setState({ payedQr: url })
        })
    }

    onClickJoinedOk () {
        if (this.state.myActivity) {
            location.assign(`/channel/group_buy?id=${this.state.myActivity.id}`)
        }
    }

    onClickBuyDialog () {
        this.setState({
            isShowBuyDialog: false
        })
    }

    render() {
        const {
            isShowShareGuide, isPending, channel, groupBuy, deadlineInfo,
            status, members, groupActivity, isShowToast, toastText, isNotFound,
            isShowPayedDialog, payedDesc, payedQr, payedTitle, payedBottom, isShowBuyDialog
        } = this.state

        if (isPending) {
            return <Toast icon="loading" show={true}>正在获取数据</Toast>
        }
        if (isNotFound) {
            return <CommonDialog self={this} />
        }

        return (
            <Page>
                <Pay />
                <ShowDialogAfterBuy isShow={isShowBuyDialog} onClickBuyDialog={() => this.onClickBuyDialog()}/>
                <div className="channel-group-buy-page wk-page">
                    <div className="top-wrap">
                        <div className="circle"></div>
                        {/* 成功参与但是没成团 */}
                        {
                            (status === 'joined' || status === 'noJoin') && (
                                <div>
                                    <Countdowner deadlineInfo={deadlineInfo} />
                                </div>
                            )
                        }
                        {/* 活动结束 */}
                        {
                            status === 'close' && (
                                <div className='close'>
                                    <img src={closeIconImg} alt=""/>
                                    <div className="close-text">来晚了，此拼团已结束</div>
                                </div>
                            )
                        }
                        {/* 拼团失败 */}
                        {
                            status === 'fail' && (
                                <div className='close'>
                                    <img src={failImg} alt=""/>
                                    <div className="close-text">很遗憾！拼团失败</div>
                                </div>
                            )
                        }
                        {/* 拼团成功 */}
                        {
                            status === 'success' && (
                                <div className='close'>
                                    <img src={successIconImg}  alt=""/>
                                    <div className="close-text">恭喜你！拼团成功</div>
                                </div>
                            )
                        }

                        {/* 专栏详情 */}
                        <div className="channel" onClick={e => location.assign(`/channel/${channel.id}`)}>
                            <div className="left">
                                <div className="cover">
                                    <img src={channel.cover_url} alt=""/>
                                </div>
                            </div>
                            <div className="right">
                                <div className="title text-cut-2">{channel.name}</div>
                                <div className="bottom">
                                    <div className="bottom-left">
                                        <div className="bottom-left-left">已更新{channel.lecture_count}期</div>
                                        <div className="bottom-left-right">{renderPopular(channel.popular)}人气</div>
                                    </div>
                                    <div className="bottom-right">
                                        原价
                                        <span className='big'>￥{renderMoney(channel.money)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 中间状态文字 */}
                    {
                        status === 'joined' && (
                            <div>
                                <div className='status-text'>
                                    <span>你已成功付款，还差</span>
                                    <span className='num'>{groupActivity.remain_num}</span>
                                    <span>人成团</span>
                                </div>
                                <div className='sub-status-text'>
                                    <span>成功拼团只剩最后一步啦！</span>
                                </div>
                                {/* <div className="share-btn">
                                    邀请好友参与
                                </div> */}

                            <div className="share_introduce_frame_wrap">
                                <div className="share_introduce_wrap">
                                    <div className="share_introduce_item">
                                        <div className="share_introduce_item_icon share_introduce_item_iconOne" style={{backgroundImage: 'url(https://static-1253442168.file.myqcloud.com/xupload/20190604_ico-genduo.png)'}} />   
                                        <p className="share_introduce_item_text">点击右上角</p> 
                                    </div> 
                                    <div className="share_introduce_item share_introduce_item_line"></div> 

                                    <div className="share_introduce_item">
                                        <div className="share_introduce_item_icon share_introduce_item_iconTwo"  style={{backgroundImage: 'url(https://static-1253442168.file.myqcloud.com/xupload/20190604_ico-fenxiang.png)'}} />   
                                        <p className="share_introduce_item_text">点击图标</p>  
                                    </div> 
                                    
                                    <div className="share_introduce_item share_introduce_item_line"></div> 

                                    <div className="share_introduce_item">
                                        <div className="share_introduce_item_icon share_introduce_item_iconThree"  style={{backgroundImage: 'url(https://static-1253442168.file.myqcloud.com/xupload/20190604_ico-pintuan.png)'}} />    
                                        <p className="share_introduce_item_text">邀好友一起拼团</p>  
                                    </div> 
                                </div>
                            </div>

                            </div>

                        )
                    }
                    {
                        status === 'noJoin' && (
                            <div>
                                <div className='status-text'>
                                    <span>本组仅剩</span>
                                    <span className='num'>{groupActivity.remain_num}</span>
                                    <span>个名额</span>
                                </div>
                                {/* <p className="hotLecture_tips">爆款好课 最低<i>1</i>元</p> */}
                                <div className="share-btn breathe" onClick={() => this.onClickPayGroupBuy()}>
                                    拼团只需 ￥{renderMoney(groupBuy.price)}
                                </div>
                            </div>

                        )
                    }
                    {/* {
                        (status === 'close' || status === 'fail') && (
                            <div>
                                <div className="share-btn" onClick={e => location.assign(`/channel/${channel.id}`)}>
                                    查看专栏详情
                                </div>
                            </div>

                        )
                    } */}
                    {
                        status === 'success' && (
                            <div>
                                <div className="share-btn" onClick={e => location.assign(`/channel/${channel.id}`)}>
                                    开始学习
                                </div>
                            </div>

                        )
                    }

                    {
                        (status === 'close' || status === 'fail') && (
                            <div>
                                <div className="share-btn" onClick={e => location.assign(`/channel/${channel.id}`)}>
                                    原价购买
                                </div>
                            </div>
                        )
                    }

                    <div className="members">
                        <WKGreenTitle title='拼团成员' className='title' />
                        {
                            members.map((item, i) => (
                                <div className="member" key={item.member.id}>
                                    <div className="avatar">
                                        <img src={item.member.avatar_url} alt=""/>
                                    </div>
                                    <div className="content">
                                        <div className="name">
                                            <span className="text-cut nick-name">{item.member.nickname}</span>
                                            {
                                                item.member.is_leader && <span className="leader-icon">团长</span>
                                            }     
                                        </div>
                                        <div className="time">
                                            {i === 0 ? '开团' : '参团'}时间：{TimeStream(item.access.create_time)}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                    <div className="notes">
                        <WKGreenTitle title='拼团须知' className='title' />
                        <div className="note">1. 分享给好友一起拼团，凑够人数拼团一起听课</div>
                        <div className="note">2. 限时内未凑够人数，支付的拼团费原路返还</div>
                    </div>
                    {/*{*/}
                        {/*isShowShareGuide && (*/}
                            {/*<div */}
                                {/*className="share-guide" */}
                                {/*onClick={() => this.setState({ isShowShareGuide: false })}*/}
                            {/*>*/}
                                {/*<Mask />*/}
                                {/*<img src={groupShareGuideImg} alt=""/>*/}
                            {/*</div>*/}
                        {/*)*/}
                    {/*}*/}

                    <WKOwnDialog type="ios" title='' buttons={[
                        { label: '去听课', onClick: () => location.assign(`/channel/${channel.id}`) }
                    ]} show={this.state.isShowBuyedDialog}>
                        你已购买过此专栏，无需重复购买
                    </WKOwnDialog>
                    <WKOwnDialog type="ios" title='' buttons={[
                        { label: '知道了', onClick: () => location.reload() }
                    ]} show={this.state.isShowFullDialog}>
                        手慢了，拼团名额已满
                    </WKOwnDialog>
                    <WKOwnDialog type="ios" title='' buttons={[
                        { label: '取消', type: 'default', onClick: () => this.setState({ isShowJoinedDialog: false }) },
                        { label: '查看', onClick: () => this.onClickJoinedOk() }
                    ]} show={this.state.isShowJoinedDialog}>
                        你当前处于拼团中，不可拼团
                    </WKOwnDialog>
                    <CommonDialog self={this} />
                    <div className="qr-dialog-groupbuy">
                        <WKOwnDialog type="ios" title={payedTitle} buttons={[{
                            label: '关闭',
                            onClick: e => this.setState({ isShowPayedDialog: false })
                        }]} show={isShowPayedDialog}>
                            <p>{payedDesc}</p>
                            <p className="content__qrcode"><img src={payedQr} alt=""/></p>
                            <p>{payedBottom}</p>
                        </WKOwnDialog>
                    </div>
                    <Toast icon="loading" show={isShowToast}>{toastText}</Toast>
                </div>
            </Page>
        )
    }
}


function Countdowner(props) {
    return (
        <div className="count-down">
            <div className="title">
                距离拼团结束仅剩
            </div>
            <div className="timer" style={{backgroundImage: `url(${timerBgImg})`}}>
                <div className="hour">{props.deadlineInfo.hour}</div>
                <div className="minute">{props.deadlineInfo.minute}</div>
                <div className="second">{props.deadlineInfo.second}</div>
            </div>
        </div>
    )
}


class CommonDialog extends React.Component {
    onClickOk () {
        if (this.props.self.state.isNotFound) {
            history.back()
        } else {
            this.props.self.setState({ isShowCommonDialog: false })
        }
    }

    render () {
        return (
            <WKOwnDialog type="ios" title='' buttons={[
                { label: '知道了', onClick: () => this.onClickOk() }
            ]} show={this.props.self.state.isShowCommonDialog}>
                {this.props.self.state.commonDialogText}
            </WKOwnDialog>
        )
    }
}

function ShowDialogAfterBuy(props) {
    if (!props.isShow) {
        return null
    }
    return (
            <div className="showDialogAfterBuy">
                <div className="mask" onClick={() => props.onClickBuyDialog()}></div>
                <div className="Dialog" onClick={(e) => e.stopPropagation()}>
                    <p className="bigTitle">拼团成功</p>
                    <p className="subTitle">课程可反复收听</p>
                    <div className="qrcodeWrap">
                        <img className="qrcodeArea" src="https://static-1253442168.image.myqcloud.com/picture/10490565_bec4e5259f9cedbfcedf2ab19a8c203f.jpg" />
                    </div>
                    <p className="tips">
                        长按扫码关注，接收课程提醒<br/>
                        享受更多优惠
                    </p>
                </div>
            </div>
        )
}


export default connect(state => ({
    account: state.account,
}))(ChannelGroupBuyPage)



// WEBPACK FOOTER //
// ./src/pages/channel/ChannelGroupBuyPage.js